module.exports = ".redValidationClass\r\n{\r\n    color: red;  \r\n}\r\n"